export default __webpack_public_path__ + "static/media/Geometria-Medium.5451c71b.woff";